//
// locales/glitch/zh-CN.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/zh-CN';
import localeData from 'react-intl/locale-data/zh.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
